var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"mdc-icon-button am-icon-button",attrs:{"href":_vm.href}},'component',_vm.$attrs,false),_vm.$listeners),[_c('am-icon',{attrs:{"icon":_vm.icon,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }